import { Component, Input } from '@angular/core';

@Component({
  selector: 'ng-run-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent {
  @Input() label: string;

  @Input() checked: boolean;
}
